import * as React from 'react';
import { BreadcrumbList } from '@grandvisionhq/analytics';

const Breadcrumbs = ({ pages , documentName  })=>{
    if (!pages) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "breadcrumbs",
        "data-t": "breadcrumbs"
    }, pages.map((page, index)=>index + 1 < pages.length ? /*#__PURE__*/ React.createElement("span", {
            key: page.name,
            className: "breadcrumbs__link-wrapper"
        }, /*#__PURE__*/ React.createElement("a", {
            href: page.url,
            className: "breadcrumbs__link",
            "data-t": "breadcrumbs-link"
        }, page.name)) : /*#__PURE__*/ React.createElement("span", {
            key: page.name,
            className: "breadcrumbs__current-page-text"
        }, documentName !== null && documentName !== void 0 ? documentName : page.name)
    ), /*#__PURE__*/ React.createElement(BreadcrumbList, {
        breadcrumbs: pages.slice(0, -1)
    }));
};

export { Breadcrumbs as default };
//# sourceMappingURL=Breadcrumbs.js.map
